// import axios from "axios";

export default {
  COMPNAME: "avue-echart-",
  NAME: "list",
  DEAFNAME: 'item'
}
export const baseUrl = "/"

//后端访问地址
// if(process.env.NODE_ENV === "production"){ //生产环境
//   axios.defaults.baseURL = origin
//   window.requestUrl = origin
//   window.wsUrl = origin.replace(window.location.protocol, 'ws:') //websocket
// }
// else{ //http://demo.jetlinks.cn
//   axios.defaults.baseURL = 'http://192.168.23.223:8844'
//   window.wsUrl = 'ws://192.168.23.223:8844'
//   window.requestUrl = 'http://192.168.23.223:8844'
// }
